// extracted by mini-css-extract-plugin
export default {"section":"Main_section__ALOHb","content":"Main_content__EcgWZ","block":"Main_block__q92wO","title":"Main_title__E4Eoq","blue":"Main_blue__kUYDf","subtitle":"Main_subtitle__FUhMs"};